// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 25px;
  overflow: hidden;
  width: 130px;
  height: 40px;
`;

export const SwitchButton = styled.div`
  flex: 1;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  background-color: ${(props) => (props.active ? 'black' : 'white')};
  color: ${(props) => (props.active ? 'white' : 'lightgray')};
  border-radius: ${(props) => (props.active ? '25px' : '0')};
  transition: all 0.3s ease;
  span {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: 16px;
    margin: 0 10px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      font-size: 14px;
    }
  }
  &:first-child {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }

  &:last-child {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }
`;
